import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
import { Drawer, Select, Table, Spin } from "antd";
import { Trash } from "feather-icons-react/build/IconComponents";
import Table1 from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import Swal from "sweetalert2";
import {
  RotateCcw,
  Filter,
  Search,
  Eye,
} from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const SalaryAdvance = () => {


  // const [editData, setEditData] = useState(null);
  // const [formSalary, setFormSalary] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [advanceAmount, setAdvanceAmount] = useState("");
  const [emiAmount, setEmiAmount] = useState("");
  const [tenure, setTenure] = useState("");
  const [lastEmiDate, setLastEmiDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  const [selectedEmpRegId, setSelectedEmpRegId] = useState([0]);
  const [branchesList, setBranchesList] = useState([]);
  const [SelectedBranchId, setSelectedBranchId] = useState([0]);
  const [PayPeriodlist, setPayPeriodlist] = useState([]);
  const [SalaryAvnceData, setSalaryAvnceData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [DeptList, setDeptList] = useState([]);
  const [SelectedDeptId, setSelectedDeptId] = useState([0]);
  const [selectedPayPeriod, setSelectedPayPeriod] = useState([0]);
  const [formBranchId, setFormBranchId] = useState(null);
  const [formDeptId, setFormDeptId] = useState(null);
  const [formEmpId, setFormEmpId] = useState(null);
  const [drawerEmployees, setDrawerEmployees] = useState([]);
  const [filterEmployees, setFilterEmployees] = useState([]);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  // const [RegId, setRegId] = useState(null);
  const [drawerHistoryList, setDrawerHistoryList] = useState([]);
  const [drawerHistoryLoading, setDrawerHistoryLoading] = useState(false);
  const [historyDrawerOpen, setHistoryDrawerOpen] = useState(false);
  const [advanceHistoryList, setAdvanceHistoryList] = useState([]);
  console.log(advanceHistoryList, "keeiufheifjefioejfefioejff")
  const [advanceHistoryLoading, setAdvanceHistoryLoading] = useState(false);
  const [selectedAdvanceId, setSelectedAdvanceId] = useState(null);
  const [historyEmpName, setHistoryEmpName] = useState("");
  const [historyEmpStatus, setHistoryEmpStatus] = useState(false);


  console.log(selectedAdvanceId, "wufhewufheufhfuhuwehfwihwfiwwihiuf")


  const navigate = useNavigate();
  const renderStatusDot = (status) => (
    <span
      title={status ? "Active" : "Pending"}
      style={{
        display: "inline-block",
        width: 12,
        height: 12,
        borderRadius: "50%",
        backgroundColor: status ? "green" : "gold",
      }}
    />
  );

  const Columns = [
    {
      title: "Badge",
      dataIndex: "Badge",
      key: "Badge",
    },
    {
      title: " Name",
      dataIndex: "EmployeeName",
      key: "EmployeeName",
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
        </span>
      ),
    },

    {
      title: "Start",
      dataIndex: "StartDate",
      key: "StartDate",
    },
    {
      title: "Advance (₹)",
      dataIndex: "AdvanceAmt",
      key: "AdvanceAmt",
    },
    {
      title: "EMI ",
      dataIndex: "EmiAmount",
      key: "EmiAmount",
    },

    {
      title: "Paid ",
      dataIndex: "PaidAmount",
      key: "PaidAmount",
    },
    {
      title: "Balance (₹)",
      dataIndex: "BalanceAmt",
      key: "BalanceAmt",
    },
    {
      title: "EMI (Pd/Tot)",
      key: "emi",
      render: (_, record) => (
        <span>
          {record.EmipendingTotal}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (status) => renderStatusDot(status),
    },
    {
      title: "Actions",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action gap-2">
            <Link
              title="View EMI History"
              onClick={() => {
                setSelectedAdvanceId(record.AdvancePaymentId);
                setHistoryEmpName(record.EmployeeName);
                setHistoryEmpStatus(record.Status);
                setHistoryDrawerOpen(true);
                fetchAdvanceEmiHistory(record.AdvancePaymentId);
              }}
            >
              <Eye className="feather-trash" />
            </Link>

            {/* Delete */}
            <Link className="me-2 p-2" onClick={() => handleDelete(record)}>
              <Trash className="feather-trash" />
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const emiHistoryColumns = [
    {
      title: "Taken On",
      dataIndex: "StartDate",
      render: (val) => formatDate(val),
    },
    {
      title: "Advance (₹)",
      dataIndex: "AdvanceAmt",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    {
      title: "EMI (₹)",
      dataIndex: "EmiAmount",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    {
      title: "EMI (Pd/Tot)",
      key: "emi",
      render: (_, record) => (
        <span>
          {record.EmipendingTotal}
        </span>
      ),
    },
    {
      title: "Balance (₹)",
      dataIndex: "BalanceAmt",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
  ];
  const advanceEmiHistoryColumns = [
    {
      title: "S.No",
      key: "sno",
      width: 60,
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "EMI PaidOn",
      dataIndex: "CreatedOn",
      render: (val) => formatDate(val),
    },
    {
      title: "EMI Amount (₹)",
      dataIndex: "Emi",
      render: (val) => `₹${val?.toLocaleString("en-IN")}`,
    },
  ];


  const handleReload = () => {
    window.location.reload();
  };
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const calculateTenureAndDate = (advanceAmount, emiAmount, startDate) => {
    if (!advanceAmount || !emiAmount || !startDate) {
      setTenure("");
      setLastEmiDate("");
      return;
    }
    if (Number(emiAmount) > Number(advanceAmount)) {
      Swal.fire({
        icon: "error",
        title: "Invalid EMI",
        text: "EMI amount cannot be greater than Advance amount",
      });

      setEmiAmount("");
      setTenure("");
      setLastEmiDate("");
      return;
    }

    const calculatedTenure = Math.ceil(
      Number(advanceAmount) / Number(emiAmount)
    );
    setTenure(calculatedTenure);

    const start = new Date(startDate);
    const lastDate = new Date(start);
    lastDate.setMonth(start.getMonth() + calculatedTenure);

    setLastEmiDate(lastDate.toISOString().split("T")[0]);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (!superIdData) return;

    const fetchDrawerEmployees = async () => {
      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${formBranchId}&DeptId=${formDeptId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        const data = await response.json();
        setDrawerEmployees(data.status ? data.ResultData : []);
      } catch {
        setDrawerEmployees([]);
      }
    };

    fetchDrawerEmployees();
  }, [superIdData, formBranchId, formDeptId]);

  useEffect(() => {
    if (!superIdData) return;

    const fetchTableEmployees = async () => {
      try {
        const branchId = showAdvancedSearch ? SelectedBranchId : 0;
        const deptId = showAdvancedSearch ? SelectedDeptId : 0;

        // In advanced search, wait until both selected
        if (showAdvancedSearch && (!branchId || !deptId)) {
          setFilterEmployees([]);
          return;
        }

        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${branchId}&DeptId=${deptId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        const data = await response.json();
        setFilterEmployees(data.status ? data.ResultData : []);
      } catch (error) {
        console.error("Employee fetch error:", error);
        setFilterEmployees([]);
      }
    };

    fetchTableEmployees();
  }, [
    superIdData,
    showAdvancedSearch,
    SelectedBranchId, SelectedDeptId
  ]);
  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranchsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Branches");
          }

          const data = await response.json();

          if (data.status) {
            setBranchesList(data.ResultData);
          } else {
            console.error("Invalid Branches response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching BranchesList:", error.message);
        }
      };
      fetchBranchsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDeptList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Dept");
          }

          const data = await response.json();

          if (data.status) {
            setDeptList(data.ResultData);
          } else {
            console.error("Invalid Dept response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching DeptList:", error.message);
        }
      };
      fetchDeptList();
    }
  }, [superIdData, tokenData]);

  const fetchDrawerHistory = async (empId) => {
    if (!tokenData || !superIdData || !empId) return;

    setDrawerHistoryLoading(true);

    try {
      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/AdvancePayments/getSalaryAdvances?SuperId=${superIdData}&EmployeeId=${empId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      const data = await response.json();

      if (data.status) {
        setDrawerHistoryList(data.ResultData || []);
      } else {
        setDrawerHistoryList([]);
      }

    } catch (error) {
      console.error("Drawer History Error:", error);
      setDrawerHistoryList([]);
    } finally {
      setDrawerHistoryLoading(false);
    }
  };
  const fetchAdvanceEmiHistory = async (advancePaymentId) => {
    if (!advancePaymentId) return;

    setAdvanceHistoryLoading(true);
    setAdvanceHistoryList([]);

    try {
      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/AdvancePayments/getAdvancePaymentsHistory?AdvancePaymentId=${advancePaymentId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      const data = await response.json();

      if (data.status) {
        setAdvanceHistoryList(data.ResultData || []);
      }
    } catch (err) {
      console.error("Advance EMI History Error:", err);
      setAdvanceHistoryList([]);
    } finally {
      setAdvanceHistoryLoading(false);
    }
  };


  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchPayPeriodsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Employees");
          }

          const data = await response.json();

          if (data.status) {
            setPayPeriodlist(data.ResultData);
          } else {
            console.error("Invalid Employees response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching EmployeesList:", error.message);
        }
      };
      fetchPayPeriodsList();
    }
  }, [superIdData, tokenData]);

  const resetAdvanceForm = () => {
    setFormEmpId(null);
    setStartDate("");
    setAdvanceAmount("");
    setEmiAmount("");
    setTenure("");
    setLastEmiDate("");
  };

  const saveEdit = async () => {
    if (!formEmpId || !startDate || !advanceAmount || !emiAmount || !tenure) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill all required fields",
        confirmButtonText: "OK",
      });
      return;
    }

    const payload = {
      SuperId: superIdData,
      RegId: formEmpId,
      StartDate: startDate,
      AdvanceAmount: Number(advanceAmount),
      Emi: Number(emiAmount),
      Tenure: Number(tenure),
      CreatedBy: 1,
    };

    try {
      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/AdvancePayments/AddAdvancePayments`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (data.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Advance added successfully",
          confirmButtonText: "OK",
        }).then(() => {
          resetAdvanceForm();
          setDrawerOpen(false);
          fetchEmployeeData();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.ErrorMsg || "Unable to add advance",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while saving",
        confirmButtonText: "OK",
      });
      console.error("Add Advance Error:", error);
    }
  };

  const handleDelete = async (record) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This advance payment will be deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    const payload = {
      AdvancePaymentId: record.AdvancePaymentId,
      UpdatedBy: 1,
    };

    try {
      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/AdvancePayments/deleteAdvancePayments`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (data.status) {
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Advance payment deleted successfully",
          confirmButtonText: "OK",
        }).then(() => {
          fetchEmployeeData();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.ErrorMsg || "Unable to delete advance payment",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while deleting",
        confirmButtonText: "OK",
      });
      console.error("Delete Advance Error:", error);
    }
  };


  const fetchEmployeeData = async (empRegId = 0) => {
    if (!tokenData || !superIdData) return;

    setDataLoading(true);

    try {
      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/AdvancePayments/getSalaryAdvances?SuperId=${superIdData}&EmployeeId=${empRegId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${tokenData}`,
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SalaryAvnceData");
      }

      const data = await response.json();

      if (data.status) {
        setSalaryAvnceData(data.ResultData || []);
      } else {
        console.error("API Error:", data.ErrorMsg);
      }
    } catch (error) {
      console.error("Error fetching SalaryAvnceData CTC:", error);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployeeData(selectedEmpRegId ?? 0);
  }, [selectedEmpRegId, tokenData, superIdData]);

  const drawerEmpOptions = [
    ...(drawerEmployees.map(emp => ({
      label: emp.UserName,
      value: emp.RegId,
      setRegId: emp.RegId,
    })) || []),
  ];
  const BranchesOptions = [
    { label: "All Branches", value: 0 },
    ...(branchesList?.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })) || []),
  ];
  const addBranchesOptions = [
    ...(branchesList?.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })) || []),
  ];
  const DeptOptions = [
    { label: "All Dept", value: 0 },
    ...(DeptList?.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })) || []),
  ];
  const addDeptOptions = [
    ...(DeptList?.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })) || []),
  ];

  const PayperiodOptions = [
    { label: "All PayPeriods", value: 0 },
    ...(PayPeriodlist?.map((period) => ({
      label: period.Name,
      value: period.Id,
    })) || []),
  ];

  return (
    <>
      <style>
        {`
  .ctc-table .ant-table-thead > tr > th {
    background-color: #d2e6f5ff !important; /* light blue */
  }
.ctc-info-2col {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 🔹 two per row */
  column-gap: 20px;
  row-gap: 8px;
}

.ctc-pair {
  display: flex;
  align-items: start;
}

.ctc-label {
  min-width: 100px; /* 🔹 keeps alignment */
  font-weight: 600;
}

.ctc-label::after {
  margin-right: 6px;
}

.ctc-value {
  font-weight: 500;
}


`}
      </style>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="page-header m-2">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      SalaryAdvance
                    </h4>
                  </ol>
                </nav>
                <h6>Manage employee salary details</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-success"
                  onClick={(e) => {
                    e.preventDefault();
                    setDrawerOpen(true);
                  }}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 p-0">
                <div className="search-set "></div>
                <div className="d-flex align-items-center flex-wrap row-gap-3">
                  <h5 className="mb-2  me-2 ">
                    Pay Period: {selectedPayPeriod?.label || "All PayPeriods"}
                  </h5>
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="grid" className="info-img" />

                      <Select
                        showSearch
                        labelInValue
                        placeholder="Select PayPeriod"
                        value={selectedPayPeriod}
                        onChange={(option) => setSelectedPayPeriod(option)}
                        options={PayperiodOptions}
                        style={{ width: 170, height: 37 }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                  </div>

                  {/* Branch & Dept (Advanced Search Only) */}
                  {showAdvancedSearch && (
                    <>
                      <div className="dropdown me-2 pt-3">
                        <div className="input-blocks">
                          <i data-feather="check-circle" className="info-img" />
                          <Select
                            showSearch
                            placeholder="Select Branch"
                            value={SelectedBranchId}
                            onChange={(val) => setSelectedBranchId(val)}
                            options={BranchesOptions}
                            style={{ width: 170, height: 37 }}
                            filterOption={(input, option) =>
                              option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </div>
                      </div>

                      <div className="dropdown me-2 pt-3">
                        <div className="input-blocks">
                          <i data-feather="check-circle" className="info-img" />
                          <Select
                            showSearch
                            placeholder="Select Dept"
                            value={SelectedDeptId}
                            onChange={(val) => setSelectedDeptId(val)}
                            options={DeptOptions}
                            style={{ width: 170, height: 37 }}
                            filterOption={(input, option) =>
                              option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* Employee Dropdown (Always Visible) */}
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <Select
                        showSearch
                        placeholder="Select Employee"
                        value={selectedEmpRegId}
                        onChange={(val) => setSelectedEmpRegId(val)}
                        options={[
                          { label: "All Employees", value: 0 },
                          ...filterEmployees.map((emp) => ({
                            label: emp.UserWithBadge,
                            value: emp.RegId,
                          })),
                        ]}
                        style={{ width: 200, height: 37 }}
                        optionFilterProp="label"
                        virtual={false}
                      />
                    </div>
                  </div>
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <button
                        type="button"
                        className={`btn btn-outline-primary d-flex align-items-center justify-content-center ${showAdvancedSearch ? "active" : ""
                          }`}
                        onClick={() => {
                          setShowAdvancedSearch((prev) => !prev);
                          setSelectedDeptId(0);
                          setSelectedBranchId(0);
                          setSelectedEmpRegId(0);
                        }}
                        title={showAdvancedSearch ? "Close Advanced Search" : "Open Advanced Search"}
                        style={{ width: 38, height: 38 }}
                      >
                        {showAdvancedSearch ? (
                          <Search
                            size={26}
                            style={{ transform: "scale(1.7)" }}
                          />
                        ) : (
                          <Filter
                            size={26}
                            style={{ transform: "scale(1.7)" }}
                          />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                {dataLoading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <Table1 columns={Columns} dataSource={SalaryAvnceData} rowKey="id" pgno={true} />
                )}
              </div>
            </div>
          </div>
        </div>

        <Drawer
          placement="right"
          width={520}
          open={drawerOpen}
          destroyOnClose
          closable={false}
          onClose={() => setDrawerOpen(false)}
          title={
            <div className="d-flex align-items-center justify-content-between">
              <span className="fw-semibold">Add Salary Advance</span>

              <button
                type="button"
                className="btn  p-0 text-dark"
                onClick={() => setDrawerOpen(false)}
              >
                ✕
              </button>
            </div>
          }
        >
          <div className="row g-2" style={{ marginTop: "-16px" }}>
            <div className="col-6">
              <label className="form-label">Branch</label>
              {/* <Select style={{ width: "100%" }} placeholder="Select Branch" /> */}
              <Select
                showSearch
                placeholder="Select Branch"
                value={formBranchId}
                onChange={(val) => setFormBranchId(val)}
                options={addBranchesOptions}
                style={{ width: "100%" }}
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>
            <div className="col-6">
              <label className="form-label">Department</label>
              <Select
                showSearch
                placeholder="Select Dept"
                value={formDeptId}
                onChange={(val) => setFormDeptId(val)}
                options={addDeptOptions}
                style={{ width: "100%" }}
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>
            <div className="col-6">
              <label className="form-label">Employee</label>
              <Select
                showSearch
                placeholder="Select Employee"
                value={formEmpId}
                onChange={(val) => {
                  setFormEmpId(val);
                  fetchDrawerHistory(val);
                }}
                options={drawerEmpOptions}
                style={{ width: "100%" }}
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>
            <div className="col-6">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setStartDate(value);
                  calculateTenureAndDate(advanceAmount, emiAmount, value);
                }}
              />
            </div>

            <div className="col-6">
              <label className="form-label">Advance Amount</label>
              <input
                type="number"
                className="form-control"
                value={advanceAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  setAdvanceAmount(value);
                  calculateTenureAndDate(value, emiAmount, startDate);
                }}
              />
            </div>

            <div className="col-6">
              <label className="form-label">EMI Amount</label>
              <input
                type="number"
                className="form-control"
                value={emiAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  setEmiAmount(value);
                  calculateTenureAndDate(advanceAmount, value, startDate);
                }}
              />
            </div>

            <div className="col-6">
              <label className="form-label">Tenure (Months)</label>
              <input
                type="number"
                className="form-control"
                value={tenure}
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label">Last EMI Date</label>
              <input
                type="date"
                className="form-control"
                value={lastEmiDate}
                readOnly
              />
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 my-2">
            <button
              className="btn btn-secondary"
              onClick={() => {
                setDrawerOpen(false);
                resetAdvanceForm();
              }}
            >
              Cancel
            </button>
            <button className="btn btn-primary" onClick={saveEdit}>
              Save
            </button>
          </div>
          <hr />
          <h5 className="fw-semibold mb-2">History</h5>
          {drawerHistoryLoading ? (
            <div className="text-center my-4">
              <Spin size="large" />
              <p>Loading data...</p>
            </div>
          ) : (
            <Table
              columns={emiHistoryColumns}
              className="ctc-table"
              dataSource={drawerHistoryList}
              pagination={false}
              size="small"
              scroll={{ x: true }}
            />
          )}
        </Drawer>
        <Drawer
          placement="right"
          width={500}
          open={historyDrawerOpen}
          destroyOnClose
          closable={false}
          onClose={() => {
            setHistoryDrawerOpen(false);
            setAdvanceHistoryList([]);
            setSelectedAdvanceId(null);
          }}
          title={
            <div className="d-flex align-items-center justify-content-between">
              <span className="fw-semibold">
                {historyEmpName} - Advance EMI History {renderStatusDot(historyEmpStatus)}
              </span>
              {/* SAME status dot as table */}

              <button
                type="button"
                className="btn p-0 text-dark"
                onClick={() => setHistoryDrawerOpen(false)}
              >
                ✕
              </button>
            </div>
          }
        >
          {advanceHistoryLoading ? (
            <div className="text-center my-4">
              <Spin size="large" />
              <p>Loading history...</p>
            </div>
          ) : (
            <Table
              columns={advanceEmiHistoryColumns}
              dataSource={advanceHistoryList}
              pagination={false}
              size="small"
              className="ctc-table"
              rowKey={(row, index) => index}
            />
          )}
        </Drawer>


        {/* Footer */}
        <CommonFooter />
      </div>
    </>
  );
};

export default SalaryAdvance;
